import React from 'react';
import { useNavigate } from 'react-router-dom';
import api  from '@/shared/api/api';
import { AdminLayout } from '@/components/Layout/Layout';
import EmployeeForm from './EmployeeForm';
import Button from '@/shared/ui/Buttons/Button';


function EmployeeCreate() {
    const navigate = useNavigate();

    const onSubmit = (data: any) => { api.employees.createEmployeesApiEmployeesPost(data).then(() => navigate('/employees')).catch((err) => console.log('err', err)) }

    return (
        <AdminLayout>
            <div className='FormRow'>
                <Button onClick={() => navigate(-1)} style={{maxWidth: "100px"}}>Назад</Button>
                <h1 className='text-30'>Новый сотрудник</h1>
            </div>
            <EmployeeForm defaultData={{}} onSubmit={onSubmit} />
        </AdminLayout>
    )
}

export default EmployeeCreate